import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "../../api/auth";
import { useAuth } from "../../context/AuthContext";
import Button from "../shared/Button";
import Input from "../shared/Input";
import Card from "../shared/Card";
import Swal from "sweetalert2";
import logo from "../../assets/chatea.png";

const RegisterForm = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirm_password: "",
    first_name: "",
    last_name: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.username)
      newErrors.username = "El nombre de usuario es requerido";
    if (!formData.email) {
      newErrors.email = "El correo electrónico es requerido";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Correo electrónico inválido";
    }
    if (!formData.password) {
      newErrors.password = "La contraseña es requerida";
    } else if (formData.password.length < 6) {
      newErrors.password = "La contraseña debe tener al menos 6 caracteres";
    }
    if (formData.password !== formData.confirm_password) {
      newErrors.confirm_password = "Las contraseñas no coinciden";
    }
    if (!formData.first_name) newErrors.firstName = "El nombre es requerido";
    if (!formData.last_name) newErrors.lastName = "El apellido es requerido";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await register(formData);
      if (response.success) {
        login(response.user);
        Swal.fire({
          icon: "success",
          title: "¡Registro exitoso!",
          text: "Tu cuenta ha sido creada correctamente",
        });
        navigate("/dashboard");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Error al registrar usuario",
      });
    } finally {
      setLoading(false);
    }
  };

  const navigateToLogin = () => {
    navigate("/login");
  };

  return (
    <Card logo={logo} title="Registrarse" className="register-form">
      <form onSubmit={handleSubmit} className="register-form__form">
        <div className="register-form__row">
          <Input
            type="text"
            label="Nombre"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            error={errors.firstName}
          />
          <Input
            type="text"
            label="Apellido"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            error={errors.lastName}
          />
        </div>
        <Input
          type="text"
          label="Nombre de usuario"
          name="username"
          value={formData.username}
          onChange={handleChange}
          error={errors.username}
        />
        <Input
          type="email"
          label="Correo Electrónico"
          name="email"
          value={formData.email}
          onChange={handleChange}
          error={errors.email}
        />
        <div className="register-form__row">
          <Input
            type="password"
            label="Contraseña"
            name="password"
            value={formData.password}
            onChange={handleChange}
            error={errors.password}
          />
          <Input
            type="password"
            label="Confirmar Contraseña"
            name="confirm_password"
            value={formData.confirm_password}
            onChange={handleChange}
            error={errors.confirm_password}
          />
        </div>
        <Button type="submit" variant="primary" disabled={loading} fullWidth>
          {loading ? "Registrando..." : "Registrarse"}
        </Button>
        <p className="register-form__login" onClick={navigateToLogin}>
          ¿Ya tienes una cuenta? Iniciar sesion
        </p>
      </form>
    </Card>
  );
};

export default RegisterForm;
